import { render } from "./MaterialContent.vue?vue&type=template&id=1075aecc&scoped=true"
import script from "./MaterialContent.vue?vue&type=script&lang=js"
export * from "./MaterialContent.vue?vue&type=script&lang=js"

import "./MaterialContent.vue?vue&type=style&index=0&id=1075aecc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1075aecc"]])

export default __exports__